
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"31","height":"31","viewBox":"0 0 31 31","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.43 0c8.523 0 15.431 6.908 15.431 15.43 0 8.523-6.908 15.431-15.43 15.431C6.908 30.861 0 23.953 0 15.431 0 6.908 6.908 0 15.43 0zm7.54 22.995h-4.118v-1.837c-1.15 1.4-2.873 2.273-5.203 2.273-4.245 0-7.757-3.58-7.757-8.218S9.404 7.43 13.65 7.43h9.321v15.564zm-8.554-12.172c-2.522 0-4.406 1.775-4.406 4.39 0 2.615 1.884 4.389 4.406 4.389 2.553 0 4.436-1.774 4.436-4.39 0-2.614-1.883-4.389-4.436-4.389z","fill":"currentColor"}})])
          )
        }
      }
    